import React from 'react'
import { FlexDiv } from '../../../../elements/NumberInput/NumberInputStyles'
import BetInput from '../../../components/betInput/BetInput'
import NumberOfRolls from '../elements/numberOfRolls/NumberOfRolls'

interface Auto_input_props {
  currency: string
  rollAmount: string
  autoMaxStake: string
  stopOnLoss: string
  stopOnProfit: string
  maxbet: number
  handleNotification: any
  handleStateUpdate: (s: string, name: string) => void
  prec: number
}
export default function AutoInputs({
  currency,
  rollAmount,
  autoMaxStake,
  maxbet,
  stopOnLoss,
  stopOnProfit,
  handleStateUpdate,
  handleNotification,
  prec,
}: Auto_input_props) {
  // currency={currency}
  // handleStake={handleStake}
  // name='STAKE'
  // maxBet={maxbet}
  // minBet={minbet}
  // stake={stake}
  // title='BET AMOUNT'
  // fontSize='24px'
  // precise={2}
  // handleNotification={handleNotification}
  return (
    <>
      <FlexDiv marginBottom='15px'>
        <NumberOfRolls
          handleRollNumber={(s: string) => handleStateUpdate(s, 'ROLL_NUMBER')}
          title='NUMBER OF ROLLS'
          rollNumber={rollAmount}
        />
        <BetInput
          stake={autoMaxStake}
          currency={currency}
          maxBet={maxbet}
          handleStake={handleStateUpdate}
          name={'MAX_STAKE'}
          title='MAX BET'
          width='148.5px'
          height='42px'
          precise={prec}
          handleNotification={handleNotification}
        />
      </FlexDiv>
      <FlexDiv marginBottom='15px'>
        <BetInput
          stake={stopOnLoss}
          currency={currency}
          handleStake={handleStateUpdate}
          title='STOP ON LOSS'
          name={'STOP_ON_LOSS'}
          width='148.5px'
          height='42px'
          precise={prec}
        />
        <BetInput
          stake={stopOnProfit}
          currency={currency}
          handleStake={handleStateUpdate}
          name={'STOP_ON_PROFIT'}
          title='STOP ON PROFIT'
          width='148.5px'
          height='42px'
          precise={prec}
        />
      </FlexDiv>
    </>
  )
}
